import keys from '@debbie/common/dist/cache/keys.js';
import { InternationalTribunalJobType, } from '@debbie/common/dist/tribunal/jobs/types.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../../utils/errors.js';
import NewEditor from '../../../editor/Editor.js';
import { useEditorState } from '../../../editor/hooks.js';
import { Button, Checkbox } from '../../../index.js';
const CloseCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const [includeNote, setIncludeNote] = useState(false);
    const editorState = useEditorState();
    const closeCaseMutation = useMutation(async () => {
        await tribunalAPI.createTribunalJob({
            type: InternationalTribunalJobType.CloseCase,
            tribunalCaseId: props.tribunalCase.id,
            data: {
                note: includeNote ? editorState.html : undefined,
            },
            caseId: props.tribunalCase.caseId,
        });
        q.invalidate(keys.write.create(tribunalJobsEntity));
        props.onSubmit();
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.tribunalCase);
        },
    });
    return (React.createElement("div", null,
        React.createElement(Checkbox, { checked: includeNote, placeholder: lang.interactions.addNote, onChange: (e) => setIncludeNote(!includeNote) }),
        includeNote && (React.createElement(NewEditor, { mentions: [], onChange: editorState.onChange, initialContent: editorState.editorContent })),
        React.createElement(Button, { onClick: () => closeCaseMutation.mutate(), loading: closeCaseMutation.isLoading, block: true }, lang.tribunal.register)));
};
export default CloseCase;
//# sourceMappingURL=CloseCase.js.map